export const environment = {
  releaseDate: '2026-07-14T15:57:29.096Z',

  firebase: {
    projectId: 'brokerage-system',
    appId: '1:476793168644:web:02bb9d88b64314d3076651',
    storageBucket: 'brokerage-system.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyCoA-NIFJa8TwmKHnxY_lQBwOVoNXWnAns',
    authDomain: 'brokerage-system.firebaseapp.com',
    messagingSenderId: '476793168644',
  },

  rollbarConfig: {
    accessToken: 'c1e967d996134b4584bc615f741721c4',
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: 'production',
    enabled: true,
    payload: {
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: '2026-07-14T15:57:29.096Z',
          guess_uncaught_frames: true,
        },
      },
    },
  },

  userbackToken: '31136|72550|2QPQmqtWXYy6xOKjy4IqlLsde',

  production: true,

  apiUrl: 'https://api.bro.etoh.digital/api',
  graphQlUrl: 'https://graphql2.bro.etoh.digital/v1/graphql',
};
